var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprinkler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H20V37H28V10Z",
    fill: "#EE8003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10H19.5C18.672 10 18 9.328 18 8.5C18 7.672 18.672 7 19.5 7H28.5C29.328 7 30 7.672 30 8.5C30 9.328 29.328 10 28.5 10Z",
    fill: "#8D6E63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.472 31.1187C34.147 30.9437 33.752 30.9637 33.446 31.1687L31.128 32.7137L29.708 31.2937C29.348 30.9337 28.774 30.9007 28.376 31.2197L26.5 32.7207L24.625 31.2197C24.26 30.9287 23.741 30.9287 23.376 31.2197L21.5 32.7207L19.625 31.2197C19.228 30.9027 18.653 30.9337 18.293 31.2937L16.873 32.7137L14.555 31.1687C14.247 30.9637 13.852 30.9437 13.529 31.1187C13.203 31.2927 13 31.6317 13 32.0007V36.0007C13 36.5537 13.448 37.0007 14 37.0007H34C34.552 37.0007 35 36.5537 35 36.0007V32.0007C35 31.6317 34.797 31.2927 34.472 31.1187Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinkler);
export default __webpack_public_path__ + "static/media/sprinkler.a3072636b071dc942c066fe715a8faec.svg";
export { ForwardRef as ReactComponent };